module.exports = __webpack_public_path__ + "static/media/BusseltonDunsborougTimes-devicecomp-min.990b7f23.webp";